import { useDesktopSidebar, useDimensions } from '../../hooks';
import Sidebar from '../Sidebar';
import { jsx as _jsx } from "react/jsx-runtime";
export function DesktopNavigation(props) {
  const [isSidebarOpen, toggleSidebar] = useDesktopSidebar();
  const {
    isTablet
  } = useDimensions();
  return /*#__PURE__*/_jsx(Sidebar, {
    copyright: false,
    open: isSidebarOpen && !isTablet,
    onToggle: isTablet ? null : toggleSidebar,
    ...props
  });
}